import { api } from "./api";

/** La figure d'une question, telle que le sujet l'imprimera.
 *
 * Le SVG est compilé au dépôt et servi tel quel : l'écran montre exactement
 * le dessin que l'élève aura sous les yeux, sans second moteur de rendu —
 * KaTeX ne saurait pas composer du CeTZ — et sans recompiler.
 *
 * L'identifiant et le drapeau plutôt qu'un objet : la banque et la relecture
 * des capacités ne nomment pas leurs questions de la même façon.
 *
 * Chargement différé : une banque de trois cents questions ne doit pas
 * demander trois cents images pour afficher sa première ligne.
 */
export default function FigureQcm({
  identifiant,
  presente,
}: {
  identifiant: string | undefined;
  presente: boolean | undefined;
}) {
  if (!identifiant || !presente) return null;
  return (
    <img
      className="figure-qcm"
      src={api.lienFigure(identifiant)}
      alt={`Figure de ${identifiant}`}
      loading="lazy"
    />
  );
}
